import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchDashboardAnalytics = createAsyncThunk(
  "analytics/fetchDashboard",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/analytics/dashboard", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load dashboard analytics"
      );
    }
  }
);

export const fetchUserAnalytics = createAsyncThunk(
  "analytics/fetchUsers",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/analytics/users", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load user analytics"
      );
    }
  }
);

export const fetchEventAnalytics = createAsyncThunk(
  "analytics/fetchEvents",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/analytics/events", { params });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to load event analytics"
      );
    }
  }
);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    dashboard: null,
    userAnalytics: null,
    eventAnalytics: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearDashboardError: (state) => {
      state.error = null;
    },
    clearAnalyticsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })
      .addCase(fetchDashboardAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserAnalytics.fulfilled, (state, action) => {
        state.userAnalytics = action.payload;
      })
      .addCase(fetchUserAnalytics.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchEventAnalytics.fulfilled, (state, action) => {
        state.eventAnalytics = action.payload;
      })
      .addCase(fetchEventAnalytics.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearDashboardError, clearAnalyticsError } =
  analyticsSlice.actions;
export default analyticsSlice.reducer;
